var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPercpethor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1694 1771 c-114 -78 -136 -91 -239 -137 -77 -34 -140 -53 -245 -75 l-85 -17 291 -1 292 -1 15 33 c29 64 92 266 84 273 -1 1 -52 -33 -113 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807 1775 c-30 -179 -129 -425 -245 -605 -34 -52 -153 -201 -197 -246 -81 -83 -235 -193 -350 -251 -144 -72 -278 -113 -470 -143 l-110 -18 592 -1 c534 -1 597 1 635 16 68 27 94 51 127 118 l31 63 -2 558 c-2 336 -6 539 -11 509z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 1518 c-58 -21 -108 -63 -139 -118 l-31 -55 -1 -565 c-2 -521 -1 -560 13 -500 46 203 151 448 258 604 22 32 47 68 55 80 33 48 139 159 212 224 47 40 198 142 257 172 161 82 382 142 591 160 41 4 -208 7 -555 8 -420 0 -640 -3 -660 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 453 c-28 -69 -46 -120 -62 -181 -8 -34 -18 -69 -22 -78 -3 -9 35 14 87 51 147 109 320 188 505 233 29 7 -31 10 -226 11 l-266 1 -16 -37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPercpethor);
export default __webpack_public_path__ + "static/media/logo_percpethor.05824dba.svg";
export { ForwardRef as ReactComponent };